/*
 *
 * Copyright (C) 2022 NetBase Solutions, Inc.
 * 3960 Freedom Circle Suite 201 Santa Clara, CA 95054
 * All rights reserved.
 */

import React from 'react'
import UnexpectedErrorBoundary from 'components/UnexpectedErrorBoundary'

import { WidgetLoadingGuard } from '../../share/guards'
import SourceAreaWidgetSettingGuards from './guards/SourceAreaWidgetSettingGuards'
import SourceAreaWidgetDataGuards from './guards/SourceAreaWidgetDataGuards'
import RunSearchEffect from './RunSearchEffect'
import Area from './Area'

const AreaDisplay = ({ widgetId }: { widgetId: number }) => (
  <UnexpectedErrorBoundary>
    <SourceAreaWidgetSettingGuards widgetId={widgetId}>
      <RunSearchEffect widgetId={widgetId}>
        <WidgetLoadingGuard widgetId={widgetId}>
          <SourceAreaWidgetDataGuards widgetId={widgetId}>
            <Area widgetId={widgetId} />
          </SourceAreaWidgetDataGuards>
        </WidgetLoadingGuard>
      </RunSearchEffect>
    </SourceAreaWidgetSettingGuards>
  </UnexpectedErrorBoundary>
)

export default AreaDisplay
